"use client";

import React from "react";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function FinalCallToAction() {
  return <section data-section-id="145261" id="calltoaction-banner" className="relative flex flex-col items-center justify-center overflow-hidden border-b-2 border-[#3B8FD4] bg-[#1A1A2E] px-5 py-24 text-center md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden opacity-[0.05]">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609985/img/goldgarage_logo_watermark.png" alt="" className="min-w-[800px] max-w-none w-[120vw] object-contain grayscale" aria-hidden="true" />
      </div>

      {}
      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center">
        <h2 className="mb-6 text-4xl font-serif font-medium leading-tight tracking-tight text-white md:text-5xl lg:text-6xl">
          Ready to Experience <br className="hidden md:block" />
          <span className="text-[#3B8FD4]">Expert Chiropractic Care?</span>
        </h2>
        
        <p className="mb-10 max-w-2xl text-lg leading-relaxed text-slate-300 md:text-xl">
          Visit our clinics in Limassol or Nicosia for professional treatment and long-lasting relief. Your journey to wellness and mobility starts today.
        </p>

        {}
        <Button asChild size="lg" className="group relative h-auto overflow-hidden rounded-full border-none bg-[#3B8FD4] px-10 py-6 text-xl font-bold text-white shadow-[0_10px_28px_rgba(59,143,212,0.35)] transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-[0_14px_35px_rgba(59,143,212,0.45)] hover:text-white md:px-14 md:py-8 md:text-2xl">
          <Link to="/BookAppointmentPage">
            <span className="absolute inset-0 flex h-full w-full justify-center [transform:skew(-12deg)_translateX(-150%)] group-hover:duration-1000 group-hover:[transform:skew(-12deg)_translateX(150%)]">
              <span className="relative h-full w-8 bg-white/20" />
            </span>
            <Phone className="mr-3 size-6 animate-[pulse_2s_ease-in-out_infinite] md:size-8" />
            Book Appointment
          </Link>
        </Button>
      </div>
    </section>;
}